import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

// export const fetchPatient = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
//     return axiosInstance.get(EndPoints.PATIENT.LIST, {
//         params: {
//             limit,
//             page_no,
//             ...filter
//         }
//     });
// }

export const createNewRegistration = (payload) => {
  return axiosInstance.post(EndPoints.CREATENEWREGISTRATION, payload);
};

// export const updatePatient = (payload) => {
//     return axiosInstance.put(EndPoints.PATIENT.UPDATE, payload)
// }

// export const deletePatient = (payload) => {
//     const url = EndPoints.PATIENT.DELETE + `/${payload}`
//     return axiosInstance.delete(url)
// }

// export const downloadCSV = () => {
//     return axiosInstance.put(EndPoints.PATIENT.DOWNLOAD_CSV, {
//         responseType: 'blob'
//     });
// }

export const fetchDocumentTypeList = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.PATIENT.DOCUMENTTYPELIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};
export const createDocumentUpload = (payload) => {
  return axiosInstance.post(EndPoints.UPLOADDOCUMENT, payload);
};

export const updateDocumentUpload = (payload) => {
  return axiosInstance.put(EndPoints.UPDATEUPLOADDOCUMENT, payload);
};

export const checkNewRegistration = (franchise_id) => {
  return axiosInstance.post(
    `${EndPoints.CHECKNEWREGISTRATION}/${franchise_id}`
  );
};
